import React from "react";
import tw from "tailwind-styled-components";
import { FaChevronRight } from "react-icons/fa";
import { FiHome, FiUsers } from "react-icons/fi";
import { LuClipboardList } from "react-icons/lu";
import { IoDocumentTextOutline } from "react-icons/io5";
import { AiOutlineNotification } from "react-icons/ai";

const settingsOptions = [
  // {
  //   title: "Property Settings",
  //   description: "View and update property details",
  //   icon: <FiHome size={24} />,
  //   modalType: "PropertySettings",
  // },
  {
    title: "Management Details",
    description: "Configure management settings",
    icon: <FiUsers size={24} />,
    modalType: "ManagementDetails",
  },
  {
    title: "Renting & Stay Rules",
    description: "Set rules for renting and stays",
    icon: <LuClipboardList size={24} />,
    modalType: "RentingStayRules",
  },
  // {
  //   title: "Dues & Payment Settings",
  //   description: "Configure payment settings",
  //   icon: <IoDocumentTextOutline size={24} />,
  //   modalType: "DuesPaymentSettings",
  // },
  {
    title: "Onboarding & KYC Settings",
    description: "Tenant verification process",
    icon: <FiUsers size={24} />,
    modalType: "TenantKYC",
  },
  {
    title: "Notification Settings",
    description: "Tenant notification settings",
    icon: <AiOutlineNotification size={24} />,
    modalType: "NotificationSettings",
  },
  {
    title: "Eviction Settings",
    description: "Configure eviction policies",
    icon: <FiUsers size={24} />,
    modalType: "EvictionSettings",
  },
  {
    title: "Tenant Onboarding Settings",
    description: "Configure onboarding settings",
    icon: <FiUsers size={24} />,
    modalType: "OnboardingSettings",
  },
];

const Table = ({ setOpenModal, settingsData }) => {
  const handleOptionClick = (modalType) => {
    if (modalType) {
      setOpenModal(modalType);
    }
  };

  return (
    <Wrapper>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ">
        {settingsOptions.map((option, index) => (
          <OptionGroup
            key={index}
            onClick={() => handleOptionClick(option.modalType)}
            className={`cursor-pointer ${
              option.modalType ? "hover:bg-gray-100 transition" : ""
            }`}
          >
            <Header>
              <div className="text-gray-600">{option.icon}</div>

              <OptionContent>
                <OptionTitle>{option.title}</OptionTitle>
                <OptionDescription>{option.description}</OptionDescription>
              </OptionContent>

              <ChevronWrapper>
                <FaChevronRight />
              </ChevronWrapper>
            </Header>
          </OptionGroup>
        ))}
      </div>
    </Wrapper>
  );
};

const Wrapper = tw.div`px-2 md:px-6 space-y-6 my-6 `;
const OptionGroup = tw.div`py-4 px-2.5 md:p-5  bg-white rounded-lg border shadow-sm`;
const Header = tw.div`flex items-center w-full px-0`;
const OptionContent = tw.div`flex flex-col ml-2 md:ml-4 `;
const ChevronWrapper = tw.div`text-gray-400 text-sm ml-auto`;
const OptionTitle = tw.h3`text-gray-900 md:text-lg text-md  font-medium`;
const OptionDescription = tw.p`text-gray-500 text-sm`;

export default Table;